/** Product display name. */
export const APP_NAME = 'SETONE SOUNDS';
/** HTTP session cookie name. */
export const SESSION_COOKIE_NAME = 'setone_sounds_sid';
/** Package / API version string for health checks. */
export const APP_VERSION = '1.0.0';
/** Common text / metadata extensions treated as TEXT. */
export const TEXT_EXTENSIONS = new Set([
    '.txt',
    '.md',
    '.markdown',
    '.json',
    '.csv',
    '.tsv',
    '.xml',
    '.yaml',
    '.yml',
    '.srt',
    '.vtt',
    '.log',
]);
/** Audio extensions treated as AUDIO. */
export const AUDIO_EXTENSIONS = new Set([
    '.wav',
    '.wave',
    '.mp3',
    '.ogg',
    '.oga',
    '.flac',
    '.aiff',
    '.aif',
    '.aifc',
    '.m4a',
    '.aac',
    '.wma',
    '.opus',
    '.webm',
]);
/**
 * Subset of audio formats that modern browsers can usually play natively
 * via HTMLAudioElement / MediaSource without a custom decoder.
 */
export const BROWSER_NATIVE_AUDIO = new Set([
    '.mp3',
    '.wav',
    '.ogg',
    '.oga',
    '.m4a',
    '.aac',
    '.flac',
    '.opus',
    '.webm',
]);
/** Default page size for directory listings. */
export const DEFAULT_PAGE_LIMIT = 50;
/** Hard ceiling for listing page size. */
export const MAX_PAGE_LIMIT = 200;
/** Default search result count. */
export const DEFAULT_SEARCH_LIMIT = 100;
/** Hard ceiling for search result count (file search returns all matches up to this). */
export const MAX_SEARCH_LIMIT = 50_000;
/** Maximum accepted search / expansion query length (chars). */
export const MAX_QUERY_LENGTH = 500;
/** Default Reciprocal Rank Fusion constant k. */
export const DEFAULT_RRF_K = 60;
/** Default multiplicative boost for exact filename matches. */
export const DEFAULT_EXACT_FILENAME_BOOST = 1.5;
/** Maximum relative path length after normalization. */
export const MAX_RELATIVE_PATH_LENGTH = 4096;
//# sourceMappingURL=constants.js.map